<template>
  <div class="termo-de-uso">
    <TermoUsoComp />
</div>
</template>

<script>

import TermoUsoComp from '@/components/TermoUsoComp.vue'

export default {
  name: 'TermoUsoView',
  components: {
    TermoUsoComp
  }
}
</script>
